
import FadingElement from '@/components/FadingElement';
import {Component, Vue} from 'vue-property-decorator';
import $ from 'jquery';
import Cookies from "js-cookie";

const COOKIE_EXPIRATION_SEC = 7776000; // 90 days
const GA_OPT_OUT_COOKIE_VALUE = 'ga_opt_out=true';

function hasGaOptOut(): boolean {
  const cookie = document.cookie;
  let result = false;
  if (cookie) {
    cookie.split(';').forEach(function(keyValue) {
      if (keyValue.trim() === 'ga_opt_out=true') {
        result = true;
      }
    });
  }
  return result;
}

function swapVisibility(hide: string, show: string) {
  $(hide).addClass('d-none');
  $(show).removeClass('d-none');
}

function updateGaStatus() {
  if (hasGaOptOut()) {
    swapVisibility('#ga-opted-in', '#ga-opted-out');
  } else {
    swapVisibility('#ga-opted-out', '#ga-opted-in');
  }
}

function gaOptOut() {
  // See https://developers.google.com/analytics/devguides/collection/analyticsjs/user-opt-out
  window['ga-disable-UA-1173427-8'] = true;
  // Set cookie to disable GA in future
  document.cookie = `${GA_OPT_OUT_COOKIE_VALUE};max-age=${COOKIE_EXPIRATION_SEC};`;
  updateGaStatus();
}

function gaOptIn() {
  window['ga-disable-UA-1173427-8'] = undefined;
  document.cookie = 'ga_opt_out=';
  updateGaStatus();
}

@Component
export default class CookieDlg extends Vue {
  private readonly needsCookieConsent = Cookies.get("CookieConsent") !== "true";
  public readonly routes = {
    ABOUT_PRIVACY: '/about/privacy',
  };
  private body = new FadingElement('#cookie-settings-dlg', 1.0);

  public mounted() {
    if (this.needsCookieConsent) {
      this.show();
    }
  }

  public show() {
    // <body> includes <main> element scrollbar.
    // This code calculates the right offset relative to <body> as diff between <body> and
    // <main> scrollable widths (which is the width of the scroll bar).
    // const rightOffset = document.body.scrollWidth - $('main').get(0).scrollWidth;
    // dlg.css('right', `${rightOffset}px`);
    // Since cookie consent is declared like "col-md-6" (that is, occupies 50% of the page width),
    // we need to adjust its left side as well, otherwise yellow background will be slightly off
    // the splitter between left and right column.
    // dlg.css('padding-left', `${Math.ceil(rightOffset / 2)}px`);
    this.body.toggle(false);
    $('#btn-cookie-consent').on('click', this.onOkClick);
    $('#btn-cookie-ga-opt-out').on('click', gaOptOut);
    $('#btn-cookie-ga-opt-in').on('click', gaOptIn);
    updateGaStatus();
  }

  private onOkClick = () => {
    document.cookie = `CookieConsent=true;max-age=${COOKIE_EXPIRATION_SEC};`;
    this.body.toggle(true);
  }
}
